import { useMutation } from '@apollo/client/react';
import { ToggleButton, MuiToggleButtonGroup } from 'components/ui';
import { useError } from 'contexts/error';
import { useLocale } from 'contexts/locale';
import EditMutation from 'mutations/user/edit';

const LanguageButton = () => {
  const setError = useError();
  const { locale, setLocale } = useLocale();

  const [editMutation, { loading }] = useMutation(EditMutation, {
    onError: () => {
      setError('error.user.profile.edit');
    },
  });

  const handleChange = async (_event, nextLocale) => {
    if (nextLocale === null || nextLocale === locale) {
      return;
    }
    try {
      await editMutation({ variables: { locale: nextLocale } });
      setLocale(nextLocale);
    } catch {
      // error already handled by onError
    }
  };

  return (
    <MuiToggleButtonGroup
      exclusive
      size="small"
      value={locale}
      onChange={handleChange}
      disabled={loading}
    >
      <ToggleButton value="pl">PL</ToggleButton>
      <ToggleButton value="en">EN</ToggleButton>
    </MuiToggleButtonGroup>
  );
};

export default LanguageButton;
